import { OFFER_TYPE } from '../../../../../../views/menu/offers/constants';

export default {
  [OFFER_TYPE.BOGO]: 'Buy 1, get 1',
  [OFFER_TYPE.FREE_ITEM]: 'Free item',
  [OFFER_TYPE.AMOUNT_OFF]: 'Amount off',
  [OFFER_TYPE.PERCENTAGE_OFF]: 'Percentage off',
};
